<template>
    <v-app>

        <router-view />

        <!-- ============================= -->
        <!-- AUTO UPDATE DIALOG -->
        <!-- ============================= -->

        <v-dialog
            v-model="showDialog"
            persistent
            max-width="500">

            <v-card class="rounded-4">

                <v-toolbar flat height="45px">
                    <span class="font-weight-bold subheading">
                        {{ dialogTitle }}
                    </span>
                </v-toolbar>

                <v-progress-linear indeterminate height="3" class="mt-0" />

                <v-card-text class="text-xs-center py-6">
                    <div v-html="dialogMessage"></div>
                </v-card-text>

            </v-card>

        </v-dialog>

    </v-app>
</template>

<script>
export default {
    name: 'app',
    data () {
        return {
            showDialog: false,
            dialogTitle: '',
            dialogMessage: '',

            waitingServiceWorker: null,
            refreshing: false,

            onControllerChange: null,
            onDownloading: null,
            onCached: null,
            onUpdated: null
        }
    },
    methods: {
        // ============================
        // SHOW UPDATE UI
        // ============================
        openUpdateUI(message) {
            this.dialogTitle = 'SweldoNow'
            this.dialogMessage = message
            this.showDialog = true
        },

        // ============================
        // AUTO UPDATE FLOW
        // ============================
        applyUpdate () {
            console.log('applyUpdate')
            if (!this.waitingServiceWorker || !this.waitingServiceWorker.waiting) 
                return

            this.openUpdateUI('Applying updates and restarting...')

            this.onControllerChange = () => {
                if (this.refreshing) 
                    return
                this.refreshing = true
                window.location.reload()
            }

            navigator.serviceWorker.addEventListener('controllerchange', this.onControllerChange)

            this.waitingServiceWorker.waiting.postMessage({
                type: 'SKIP_WAITING'
            })
        },

        // ============================
        // EVENTS
        // ============================
        handleDownloading () {
            console.log('handleDownloading')
            this.waitingServiceWorker = null
            
            // Check localStorage
            const hasVisitedFlag = localStorage.getItem('hasVisitedSweldoNow')
            
            // Check if a user ID exists in your Vuex store state
            const hasLoggedInUser = this.$store && this.$store.state && this.$store.state.userId

            // A user is ONLY considered a first-time user if BOTH checks fail
            const isFirstTime = !hasVisitedFlag && !hasLoggedInUser

            if (isFirstTime) {
                this.openUpdateUI(`Welcome! We are preparing the app for your first visit. ${this.isMobile? '': '<br>'} This might take a minute or two.`)
            } else {
                // If they have a flag or a userId, ensure the flag is explicitly saved for future visits
                if (!hasVisitedFlag) {
                    localStorage.setItem('hasVisitedSweldoNow', 'true')
                }
                this.openUpdateUI(`Downloading the latest updates. ${this.isMobile? '': '<br>'} This might take a few seconds...`)
            }
        },
        handleUpdated (event) {
            console.log('handleUpdated')
            this.waitingServiceWorker = event.detail
            this.applyUpdate()
        },

        handleFirstTimeCache () {
            console.log('handleFirstTimeCache')

            // Mark the user as a returning user for their next visit
            localStorage.setItem('hasVisitedSweldoNow', 'true')
            
            // Hide the dialog and reload to ensure everything functions perfectly
            this.showDialog = false
            window.location.reload()
        }
    },
    created () {
        this.onDownloading = this.handleDownloading
        this.onUpdated = this.handleUpdated
        this.onCached = this.handleFirstTimeCache // Fixed reference for first-time loads

        window.addEventListener('pwa-update-downloading', this.onDownloading)
        window.addEventListener('pwa-update-ready', this.onUpdated)
        window.addEventListener('pwa-update-cached', this.onCached)
    },
    beforeDestroy () {
        window.removeEventListener('pwa-update-downloading', this.onDownloading)
        window.removeEventListener('pwa-update-ready', this.onUpdated)
        window.removeEventListener('pwa-update-cached', this.onCached)

        if (this.onControllerChange) {
            navigator.serviceWorker.removeEventListener('controllerchange', this.onControllerChange)
        }
    }
}
</script>
